import { render, staticRenderFns } from "./m-todo-bar.vue?vue&type=template&id=22c0b403&scoped=true&"
import script from "./m-todo-bar.vue?vue&type=script&lang=js&"
export * from "./m-todo-bar.vue?vue&type=script&lang=js&"
import style0 from "./m-todo-bar.vue?vue&type=style&index=0&id=22c0b403&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c0b403",
  null
  
)

export default component.exports